<template>
    <div>
        <div class="page-block__item-wrapper" dusk="ssl-item">
            <administrative-status
                :label="trans('subscriptions.administrative_status')"
                :status="subscription.administrative_status"
            />
            <renewal-date :label="trans('ssl.renew-date')" :renewDate="subscription.end_date"/>
            <subscription-period
                :label="trans('ssl.period')"
                :period="subscription.period"
                :periodSuffix="trans('ssl.period-suffix')"
            />
            <subscription-type :label="trans('ssl.type')" :type="subscription.product_name" />
            <ssl-private-key v-if="(subscription.has_custom_csr || subscription.has_reissued) && subscription.has_hosting"
                :label="trans('ssl.private_key')"
                :subscription="subscription"
            ></ssl-private-key>
            <ssl-reissue
                v-if="subscription.last_status === 'ACT'"
                :label="trans('ssl.reissue')"
                :renew-label="trans('ssl.reissue')"
                :subscription="subscription"
            ></ssl-reissue>
            <ssl-download-button :subscription="subscription" :domain="domain" />
        </div>
        <cancel-subscriptions :subscription="subscription" :domain="domain" />
    </div>
</template>

<script>
import {
    AdministrativeStatus,
    CancelSubscriptions,
    SslDownloadButton,
    SslDownloadModal,
    RenewalDate,
    ServiceCancelModal,
    SubscriptionPeriod,
    SubscriptionType,
    SslPrivateKey,
    SslReissue
} from 'relapp-technical-management';

export default {
    components: {
        AdministrativeStatus,
        CancelSubscriptions,
        SslDownloadButton,
        SslDownloadModal,
        RenewalDate,
        SubscriptionPeriod,
        SubscriptionType,
        ServiceCancelModal,
        SslPrivateKey,
        SslReissue
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    }
};
</script>
